
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['stripeCustomerHasPayment', 'subscription', 'subscriptionOptions', 'user']),
        currentPlan() {
            // Resolve the current pricing plan out of the subscription
            return this.$store.getters.plan
        }
    },
    methods: {
        cancelSubscriptionConfirm() {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'subscription-cancel-form',
                closeable: false,
                closeOnSubmit: true,
                width: '550px',
                callback: (route) => {
                    //  If a route was included, route to it
                    if (route) this.$router.push(route)
                }
            })
        },
        //  The 'data' param here is an object that can contain the plan, addons, and "today's charge" amount
        async cardAddedSuccess(token, data = null, close = true) {
            //  If the token is null do nothing
            if (!token) return

            //  Assemble the API payload
            const payload = { token: token }

            //  Send the request to the API
            const customer = await this.$store.dispatch('stripeCustomerPost', payload)

            //  Close app dialog if close param is true
            if (close) this.$store.dispatch('dialogClose', 'APP')

            //  If the request failed do nothing
            if (!customer) return

            return true
        },
        async cardUpdatedSuccess(card) {
            //  Construct our payload
            const payload = { card_id: card.id }

            //  Dispatch our request
            const customer = await this.$store.dispatch('stripeCustomerPut', payload)

            //  If the request failed do nothing
            if (!customer) return
        },
        //  The 'data' param here is an object that can contain the plan, addons, and "today's charge" amount
        goToPaymentCardAdd(data) {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: `Add Payment Card`,
                icon: 'mdi-credit-card-outline',
                color: 'primary',
                component: 'stripe-payment-card',
                closeable: true,
                props: {
                    data: data,
                    isSubscriptionMixin: true
                }
            })
        },
        //  The 'data' param here is an object that can contain the plan, addons, and "today's charge" amount
        onPlanSelectedConfirm(data) {
            //  Confirm that the selected plan is really a stripe plan
            if (data.plan === null || typeof data.plan !== 'object') return

            //  Only continue if we have payment info entered
            if (!this.stripeCustomerHasPayment) return this.goToPaymentCardAdd(data)

            //  Get the current user's role
            const role = this.$store.getters.userRole(this.user)

            //  If the user is an operator, stop them
            if (role.permission < 2) return this.popPermissionPopup()

            return this.$store.dispatch('dialogOpen', {
                type: 'APP',
                color: 'primary',
                icon: 'mdi-credit-card-outline',
                title: 'Confirm Subscription Payment',
                props: {
                    payload: data,
                    todaysCharge: data.todaysCharge
                },
                component: 'billing-subscription-dialog'
            })
        },
        popPermissionPopup() {
            //  Pop a dialog
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Insufficient Permissions',
                text: "You lack permissions to change subscriptions; you must be a Manager or an Admin. Please contact a Manager or Admin of your workspace to change subscription plans.",
                icon: 'mdi-alert'
            })
        }
    }
}